import { Flex, type FlexProps } from "antd"
import { Text } from "~/components/Text"
import classNames from "classnames"
import type { ReactNode } from "react"
import styles from "./index.css"

type PromptTextPanelVariant = "default" | "detail" | "embedded"

type PromptTextPanelProps = FlexProps & {
  footer?: ReactNode
  text: string
  variant?: PromptTextPanelVariant
}

export const PromptTextPanel = ({
  className,
  footer,
  text,
  variant = "default",
  ...others
}: PromptTextPanelProps) => {
  return (
    <Flex
      className={classNames(styles.root, className, {
        [styles.detail]: variant === "detail",
        [styles.embedded]: variant === "embedded",
      })}
      vertical
      {...others}
    >
      <Text
        size={15}
        className={styles.text}
      >
        {text}
      </Text>
      {footer ? (
        <Flex
          className={styles.footer}
          justify="flex-end"
        >
          {footer}
        </Flex>
      ) : null}
    </Flex>
  )
}
